module.exports = "<svg viewBox=\"0 0 15.4 12\" height=\"12px\" width=\"15.4px\">\n<g>\n    <path class=\"control-svg\" fill=\"#000111\" d=\"M5.5,2.7c0-1-0.7-1.7-1.7-1.7C1.4,1,1.2,4.3,1.2,6.1c0,1.7,0.2,4.9,2.5,4.9c1.2,0,1.9-0.9,1.9-2h1.2\n        c-0.1,1.9-1.3,3-3.2,3C0.5,12,0,8.5,0,6.1C0,3.5,0.5,0,3.8,0c1.6,0,2.8,1.1,2.9,2.7H5.5z\"/>\n    <path class=\"control-svg\" fill=\"#000111\" d=\"M14.1,2.7c0-1-0.7-1.7-1.7-1.7C10,1,9.8,4.3,9.8,6.1c0,1.7,0.2,4.9,2.5,4.9c1.2,0,1.9-0.9,1.9-2h1.2\n        c-0.1,1.9-1.3,3-3.2,3c-3.2,0-3.6-3.5-3.6-5.9C8.6,3.5,9.1,0,12.4,0c1.6,0,2.8,1.1,2.9,2.7H14.1z\"/>\n</g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/cc.svg
// module id = 341
// module chunks = 0